(function () {
  var ORDER = {
    'イエロー系': ['レモネード', 'ミモザ', 'ソレイユ', 'スフレ', 'キャメル', 'ユキーユ', 'フレイヴ', 'サブレ', 'ビスケット'],
    'グリーン系_LAST3': ['パシフィック', 'リケン', 'ダグラス']
  };

  function onPplrReady(cb) {
    window.addEventListener('pplrAppInitiated', function () {
      // 初回
      requestAnimationFrame(cb);

      // 監視（bodyじゃなく Zeptoのwrapperだけ）
      var wrapper = document.querySelector('.pplr-wrapper');
      if (!wrapper) return;

      var scheduled = false;
      var mo = new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;

        // DOMが落ち着いてから1回だけ
        setTimeout(function () {
          scheduled = false;
          requestAnimationFrame(cb);
        }, 120);
      });

      mo.observe(wrapper, { childList: true, subtree: true });
    }, { once: true });
  }

  function reorderAll() {
    // swatchコンテナごとに処理（ただし “一回並べたコンテナ” はスキップ）
    var containers = document.querySelectorAll('.pplr-swatch-main');
    if (!containers.length) return;

    containers.forEach(function (container) {
      if (container.dataset.reordered === '1') return; // ←ここが効く
      reorderContainer(container);
      container.dataset.reordered = '1';
    });
  }

  function reorderContainer(container) {
    var swatches = Array.prototype.slice.call(container.querySelectorAll('.pplr-swatch-element.pplrimage'));
    if (!swatches.length) return;

    var byTag = {};
    swatches.forEach(function (el, i) {
      var tag = el.getAttribute('data-tag') || '';
      if (!byTag[tag]) byTag[tag] = [];
      byTag[tag].push({ el: el, i: i, name: (el.getAttribute('data-val') || '').trim() });
    });

    // DocumentFragmentでまとめてDOM移動（軽くなる）
    applyFixedOrder(byTag, container, 'イエロー系', ORDER['イエロー系']);
    applyLast3Order(byTag, container, 'グリーン系', ORDER['グリーン系_LAST3']);
  }

  function applyFixedOrder(byTag, container, tagName, desiredNames) {
    var list = byTag[tagName];
    if (!list || !list.length) return;

    var map = new Map();
    list.forEach(function (x) { map.set(x.name, x.el); });

    var frag = document.createDocumentFragment();

    desiredNames.forEach(function (name) {
      var el = map.get(name);
      if (el) frag.appendChild(el);
    });

    list
      .filter(function (x) { return desiredNames.indexOf(x.name) === -1; })
      .sort(function (a, b) { return a.i - b.i; })
      .forEach(function (x) { frag.appendChild(x.el); });

    container.appendChild(frag);
  }

  function applyLast3Order(byTag, container, tagName, last3Names) {
    var list = byTag[tagName];
    if (!list || list.length < 3) return;

    var current = list.slice().sort(function (a, b) { return a.i - b.i; });
    var last3 = current.slice(-3);

    var last3Set = last3.map(function (x) { return x.name; }).sort().join('|');
    var targetSet = last3Names.slice().sort().join('|');
    if (last3Set !== targetSet) return;

    var map = new Map();
    last3.forEach(function (x) { map.set(x.name, x.el); });

    // 最後3つだけを差し替える（全体を再appendしない＝軽い）
    last3Names.forEach(function (n) {
      var el = map.get(n);
      if (el) container.appendChild(el);
    });
  }

  onPplrReady(reorderAll);
})();
